/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Daterangepicker_Last7days3Inputs */

const id_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7 hari terakhir`)
};

const ms_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7 hari lepas`)
};

const da_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sidste 7 dage`)
};

const de_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte 7 Tage`)
};

const en_us2_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last 7 days`)
};

const es_es2_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimos 7 días`)
};

const es_mx2_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimos 7 días`)
};

const fil_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huling 7 araw`)
};

const fr_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7 derniers jours`)
};

const it_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimi 7 giorni`)
};

const hu_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utolsó 7 nap`)
};

const nl_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laatste 7 dagen`)
};

const no_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siste 7 dager`)
};

const pl_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatnie 7 dni`)
};

const pt_br2_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimos 7 dias`)
};

const pt_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimos 7 dias`)
};

const ro_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimele 7 zile`)
};

const fi_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viimeiset 7 päivää`)
};

const sv_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senaste 7 dagarna`)
};

const vi_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7 ngày qua`)
};

const tr_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son 7 gün`)
};

const cs_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posledních 7 dní`)
};

const bg_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последни 7 дни`)
};

const ru_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последние 7 дней`)
};

const uk_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Останні 7 днів`)
};

const ar_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آخر 7 أيام`)
};

const hi_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछले 7 दिन`)
};

const th_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7 วันที่ผ่านมา`)
};

const ja_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`過去7日間`)
};

const zh_cn2_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`过去 7 天`)
};

const zh_hant1_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近7天`)
};

const ko_components_daterangepicker_last7days3 = /** @type {(inputs: Components_Daterangepicker_Last7days3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지난 7일`)
};

/**
* | output |
* | --- |
* | "Last 7 days" |
*
* @param {Components_Daterangepicker_Last7days3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_daterangepicker_last7days3 = /** @type {((inputs?: Components_Daterangepicker_Last7days3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Daterangepicker_Last7days3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_daterangepicker_last7days3(inputs)
	if (locale === "ms") return ms_components_daterangepicker_last7days3(inputs)
	if (locale === "da") return da_components_daterangepicker_last7days3(inputs)
	if (locale === "de") return de_components_daterangepicker_last7days3(inputs)
	if (locale === "en-US") return en_us2_components_daterangepicker_last7days3(inputs)
	if (locale === "es-ES") return es_es2_components_daterangepicker_last7days3(inputs)
	if (locale === "es-MX") return es_mx2_components_daterangepicker_last7days3(inputs)
	if (locale === "fil") return fil_components_daterangepicker_last7days3(inputs)
	if (locale === "fr") return fr_components_daterangepicker_last7days3(inputs)
	if (locale === "it") return it_components_daterangepicker_last7days3(inputs)
	if (locale === "hu") return hu_components_daterangepicker_last7days3(inputs)
	if (locale === "nl") return nl_components_daterangepicker_last7days3(inputs)
	if (locale === "no") return no_components_daterangepicker_last7days3(inputs)
	if (locale === "pl") return pl_components_daterangepicker_last7days3(inputs)
	if (locale === "pt-BR") return pt_br2_components_daterangepicker_last7days3(inputs)
	if (locale === "pt") return pt_components_daterangepicker_last7days3(inputs)
	if (locale === "ro") return ro_components_daterangepicker_last7days3(inputs)
	if (locale === "fi") return fi_components_daterangepicker_last7days3(inputs)
	if (locale === "sv") return sv_components_daterangepicker_last7days3(inputs)
	if (locale === "vi") return vi_components_daterangepicker_last7days3(inputs)
	if (locale === "tr") return tr_components_daterangepicker_last7days3(inputs)
	if (locale === "cs") return cs_components_daterangepicker_last7days3(inputs)
	if (locale === "bg") return bg_components_daterangepicker_last7days3(inputs)
	if (locale === "ru") return ru_components_daterangepicker_last7days3(inputs)
	if (locale === "uk") return uk_components_daterangepicker_last7days3(inputs)
	if (locale === "ar") return ar_components_daterangepicker_last7days3(inputs)
	if (locale === "hi") return hi_components_daterangepicker_last7days3(inputs)
	if (locale === "th") return th_components_daterangepicker_last7days3(inputs)
	if (locale === "ja") return ja_components_daterangepicker_last7days3(inputs)
	if (locale === "zh-CN") return zh_cn2_components_daterangepicker_last7days3(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_daterangepicker_last7days3(inputs)
	return ko_components_daterangepicker_last7days3(inputs)
});
export { components_daterangepicker_last7days3 as "components.dateRangePicker.last7Days" }